/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum models_SenderType {
    SenderTypeParent = 'parent',
    SenderTypeEmployee = 'employee',
    SenderTypeAdmin = 'admin',
}
